import React from "react";
import SearchBarDesign from "design/components/search/SearchBar";
import useSubobjects from "backend/hooks/elements/useSubobjects";
import { ICardElementWithChildren } from "backend/model/model";
import useLink from "@qpr/client-api-base/hooks/useLink";
import typeToView from "routing/typetoview";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import SearchResultRow from "design/components/search/SearchResultRow";

const SearchUsing = (
  keys: Array<keyof ICardElementWithChildren>,
  v: ICardElementWithChildren,
  searchKey: string
) => {
  let found = false;
  keys.forEach((k) => {
    if (typeof v[k] === "string") {
      if (
        v[k]
          ?.toString()
          .toLocaleLowerCase()
          .includes(searchKey.toLocaleLowerCase())
      ) {
        found = true;
      }
    }
  });
  return found;
};

const Search = () => {
  const link = useLink();
  const ctx = useAppContext();
  const { data, isLoading } = useSubobjects();
  const [results, setResults] = React.useState<
    ICardElementWithChildren[] | undefined
  >();
  const [searchCandidate, setSearchCandidate] = React.useState("");
  const [hasSearch, setHasSearch] = React.useState("");

  React.useEffect(() => {
    if (data && !isLoading && searchCandidate.length > 0) {
      let res: ICardElementWithChildren[] = data;
      searchCandidate
        .split(" ")
        .filter((v) => v)
        .forEach((searchKey) => {
          res = res
            .filter(
              (v) =>
                typeToView(v.typename) &&
                !v.scorecardname?.includes("_config") &&
                !v.symbol?.includes("D0")
            )
            .filter((v) =>
              SearchUsing(
                [
                  "name",
                  "rangename",
                  "periodlevelname",
                  "description",
                  "name",
                  "typename",
                  "scorecardname",
                  "scorecardsymbol",
                ],
                v,
                searchKey
              )
            );
        });
      setResults(res);
    } else {
      console.log("No data for search ", ctx.model);
    }
  }, [data, searchCandidate, isLoading, ctx.model]);

  return (
    <div>
      <SearchBarDesign
        maxResults={1000}
        results={results}
        RenderRow={(props) => {
          const item = { ...props.value };
          item.PERF_prettyvalue = item.PERF_YTD_prettyvalue;
          item.rangecolor = item.rangecolor_PERF_YTD_OPEN;
          if (item.typename === "Initiative") {
            item.PERF_prettyvalue = item.COMPLETION_PERCENTAGE_prettyvalue;
            item.rangecolor = item.rangecolor_default;
          }
          return <SearchResultRow value={item} onNavigate={props.onNavigate} />;
        }}
        isLoading={isLoading}
        onNavigate={(value) => {
          link({
            page: typeToView(value.typename),
            meaId: value.id,
          });
        }}
        onSearch={(value) => {
          setSearchCandidate(value);
        }}
      />
    </div>
  );
};

export default Search;
